export enum ReducerTypes {
  onConfirmAction = 'onConfirmAction',
  null = 'null',
}
